import SetDocumentNumberStep from './SetDocumentNumberStep';

export default SetDocumentNumberStep;
